import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

/**
 * Reset Password flow events for the authentication system.
 *
 * These events drive the reactive password reset process from token validation
 * to new password submission.
 *
 * @example
 * const dispatch = injectDispatch(resetPasswordEvents);
 * dispatch.resetPasswordRequested({ password: 'new-secret', token: 'reset-token' });
 */
export const resetPasswordEvents = eventGroup({
  source: 'auth.resetPassword',
  events: {
    resetPasswordRequested: type<{
      password: string;
      token: string;
    }>(),
    resetPasswordSucceeded: type<{
      accessToken: string;
    }>(),
    resetPasswordFailed: type<{
      error: string;
    }>(),
  },
});
